const COUNTRY_NORMALIZATION_MAP = {
  uae: 'UAE',
  ksa: 'KSA',
  kuwait: 'Kuwait',
  qatar: 'Qatar',
  oman: 'Oman',
  bahrain: 'Bahrain',
  gcc: 'GCC'
}

export const normalizeCountryToken = (country = '') => {
  const trimmedCountry = String(country || '').trim()
  if (!trimmedCountry) return ''

  const normalized = trimmedCountry.toLowerCase()
  return COUNTRY_NORMALIZATION_MAP[normalized] || trimmedCountry.toUpperCase()
}

export const extractCountryFromSlug = (slug = '') => {
  if (!slug) return ''
  const [rawCountry] = String(slug).split('-')
  return normalizeCountryToken(rawCountry || '')
}

export const subscriptionCoversCountry = (subscription, country) => {
  const countries = Array.isArray(subscription?.countries)
    ? subscription.countries
    : []

  if (!countries.length) return false
  if (countries.some((entry) => String(entry).toUpperCase() === 'ALL')) {
    return true
  }

  if (!country || country === 'ALL') {
    return false
  }

  return countries.some(
    (entry) => normalizeCountryToken(String(entry || '')) === country,
  )
}

export const hasSubscriptionAccessToCountry = (
  quotaStatus,
  country,
  options = {},
) => {
  const { requireDtaaAccess = false } = options
  const subscriptions = Array.isArray(quotaStatus?.activeSubscriptions)
    ? quotaStatus.activeSubscriptions
    : []

  return subscriptions.some((subscription) => {
    const isDtaaOnly = Boolean(subscription?.dtaaOnly)
    const includesDtaa = Boolean(subscription?.includesDtaa)

    if (requireDtaaAccess) {
      if (!isDtaaOnly && !includesDtaa) {
        return false
      }
      return subscriptionCoversCountry(subscription, country)
    }

    if (isDtaaOnly) {
      return false
    }

    return subscriptionCoversCountry(subscription, country)
  })
}
